import { render, staticRenderFns } from "./SurveyManagementPanel.vue?vue&type=template&id=e64eb1e4&scoped=true&"
import script from "./SurveyManagementPanel.vue?vue&type=script&lang=js&"
export * from "./SurveyManagementPanel.vue?vue&type=script&lang=js&"
import style0 from "./SurveyManagementPanel.vue?vue&type=style&index=0&id=e64eb1e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e64eb1e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e64eb1e4')) {
      api.createRecord('e64eb1e4', component.options)
    } else {
      api.reload('e64eb1e4', component.options)
    }
    module.hot.accept("./SurveyManagementPanel.vue?vue&type=template&id=e64eb1e4&scoped=true&", function () {
      api.rerender('e64eb1e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/survey-management/SurveyManagementPanel.vue"
export default component.exports